import { COMPETITORS_ACTIONS } from '../constants';

const initialState = {
  isLoading: false,
  storeId: undefined,
  activeCompetitors: [],
  allCompetitors: []
};

const competitorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPETITORS_ACTIONS.GET_COMPETITORS: {
      return {
        ...state,
        allCompetitors: action.payload.allCompetitors,
        activeCompetitors: action.payload.activeCompetitors
      };
    }
    case COMPETITORS_ACTIONS.SET_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case COMPETITORS_ACTIONS.UPDATE_COMPETITORS: {
      return {
        ...state,
        activeCompetitors: action.payload
      };
    }

    default:
      return state;
  }
};

export default competitorsReducer;
